import Contact from "../components/Contact";
import PageHero from "../components/PageHero";
import { contact } from "../lib/content";

export default function ContactPage() {
  return (
    <>
      <PageHero eyebrow={contact.eyebrow} title={contact.heading} intro={contact.subheading} />
      <Contact withHeader={false} />
    </>
  );
}
